import { useCallback, useEffect } from 'react';

import { store } from 'redux/store';
import { setTriggerRequest } from 'redux/reducers/meteorologyAgroWBCultureReducer';
import { ResponseError } from 'services/api/base';
import { useLazyGetWBCultureDVGraphQuery } from 'services/api/Meteorology/Agro/WBCulture/DetailedView';
import useParams from './useParams';

export default function useGraphData() {
  const params = useParams();
  const [trigger, {
    data, isFetching, error, originalArgs,
  }] = useLazyGetWBCultureDVGraphQuery();

  const onRetry = useCallback(() => {
    if (params) trigger(params);
  }, [params, trigger]);

  useEffect(() => {
    store.dispatch(setTriggerRequest(params ? (() => trigger(params)) : undefined));
  }, [trigger, params]);

  return {
    graphData: data?.series,
    runDate: data?.runDate ?? null,
    // Local da ÚLTIMA consulta: o do painel pode já ter mudado sem consultar de novo.
    queriedLocationId: originalArgs?.locationId,
    isFetching,
    queryError: error as ResponseError | undefined,
    onRetry,
  };
}
